import { jsx as _jsx } from "react/jsx-runtime";
import { css, styled, ThemeProvider } from 'styled-components';
import { Box } from "../../box/src";
import { useTheme, useUpdateThemeWithFontBrightness, } from "../../theme/src";
import { DropdownBase, } from './components/DropdownBase';
import { StyledSimpleBar } from './components/StyledSimpleBar';
export const DropdownWithAnyContent = ({ buttonWrapperProps = {}, children, content, dataTestId = 'ds-dropdown', isDisabled = false, isFullWidth = false, maxHeight, position = 'left', title, wrapperStyles = {}, }) => {
    const theme = useTheme();
    const updatedTheme = useUpdateThemeWithFontBrightness(theme, theme.themeVariables.inputFontBrightness);
    return (_jsx(DropdownBase, { buttonWrapperProps: buttonWrapperProps, dataTestId: dataTestId, isDisabled: isDisabled, isFullWidth: isFullWidth, maxHeight: maxHeight, position: position, renderContent: ({ contentMaxHeight, wrapperItemsRef }) => (_jsx(ThemeProvider, { theme: updatedTheme, children: _jsx(Wrapper, { ref: wrapperItemsRef, children: contentMaxHeight ? (_jsx(StyledSimpleBar, { "$maxHeight": contentMaxHeight, autoHide: true, dataTestId: "dropdown-simplebar", children: content })) : (content) }) })), title: title, wrapperStyles: wrapperStyles, children: children }));
};
const Wrapper = styled(Box).attrs(({ theme }) => ({
    bg: theme.input.bg,
    mt: 2,
})) `
  ${({ theme }) => css `
    border-radius: 5px;
    box-shadow: ${theme.dropdown.boxShadow};
  `}
`;
//# sourceMappingURL=DropdownWithAnyContent.js.map